var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonDecorationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 16.2871L0.000244141 16.2871",
    stroke: "url(#paint0_linear_146_1571)",
    className: "svg-button-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 31C34.2845 31 41.0002 24.2843 41.0002 16C41.0002 7.71573 34.2845 1 26.0002 1C17.716 1 11.0002 7.71573 11.0002 16C11.0002 24.2843 17.716 31 26.0002 31Z",
    stroke: "url(#paint1_angular_146_1571)",
    strokeOpacity: 0.4,
    className: "svg-button-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2964 16.5668L26.6363 17.8352L23.8867 19.5505L24.164 16.5285L23.9005 13.4995L26.6561 15.1846L29.2964 16.5668Z",
    fill: "white",
    className: "svg-button-3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1571",
    x1: 18.5002,
    y1: 16.2871,
    x2: 0.500244,
    y2: 16.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.198035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_146_1571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0002 16) rotate(90) scale(15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#160D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDecorationRight);
export default __webpack_public_path__ + "static/media/button-decoration-right.350288944012f8a8eb3ec4c593b6370e.svg";
export { ForwardRef as ReactComponent };